//Bootstrap
import(/* webpackChunkName: "bootstrap-collapse" */'bootstrap/js/src/collapse')
import(/* webpackChunkName: "bootstrap-dropdown" */'bootstrap/js/src/dropdown')
import(/* webpackChunkName: "bootstrap-offcanvas" */'bootstrap/js/src/offcanvas')
import(/* webpackChunkName: "bootstrap-tab" */'bootstrap/js/src/tab')

// Viewport load components
import(/* webpackChunkName: "viewport-load" */'./components/viewport-load').then((module) => {

    const ViewportLoad = module.default

    new ViewportLoad({
        selector: ".splide",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "splide-carousel" */'./components/splide-carousel').then((module) => {
                new module.default(selector)
            })
        }
    })

    new ViewportLoad({
        selector: ".quantity",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "product-quantity" */'./components/product-quantity').then((module) => {
                new module.default(selector)
            })
        }
    })
    
    new ViewportLoad({
        selector: ".product-filters",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "product-filters" */'./components/product-filters').then((module) => {
                new module.default(selector)
            })
        }
    })

    new ViewportLoad({
        selector: "#tabbed-products-with-filters",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "tabbed-product-with-filters" */'./components/tabbed-products-with-filters').then((module) => {
                new module.default(selector)
            })
        },
        singular: true
    })

    new ViewportLoad({
        selector: "#mega-menu",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "mega-menu" */'./components/mega-menu').then((module) => {
                new module.default(selector)
            })
        },
        singular: true
    })
    new ViewportLoad({
        selector: "#mobile-nav",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "mobile-search-toggle" */'./components/mobile-search-toggle').then((module) => {
                new module.default(selector)
            })
        }
    })

    new ViewportLoad({
        selector: "#print-page",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "print" */'./components/print').then((module) => {
                new module.default(selector)
            })
        },
        singular: true
    })

    new ViewportLoad({
        selector: ".share-product",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "social-share-product" */'./components/social-share-product').then((module) => {
                new module.default(selector)
            })
        },
    })

    new ViewportLoad({
        selector: ".hover-toggle-class",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "hover-toggle-class" */'./components/hover-toggle-class').then((module) => {
                new module.default(selector)
            })
        },
    })
    
    new ViewportLoad({
        selector: ".wpsl-search",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "store-search" */'./components/store-search').then((module) => {
                new module.default(selector)
            })
        },
        singular: true
    })

    new ViewportLoad({
        selector: ".woocommerce-checkout",
        callback: () => {
            import(/* webpackChunkName: "no-shipping-modal" */'./modules/no-shipping-modal').then((module) => {
                new module.default()
            })
        },
        singular: true
    })
    
    new ViewportLoad({
        selector: ".woocommerce-checkout",
        callback: () => {
            import(/* webpackChunkName: "flux-checkout" */'./components/flux-checkout').then((module) => {
                new module.default()
            })
        },
        singular: true
    })

    new ViewportLoad({
        selector: ".woocommerce-checkout",
        callback: () => {
            import(/* webpackChunkName: "apple-pay-support" */'./components/apple-pay-support').then((module) => {
                new module.default()
            })
        },
        singular: true
    })
    

    new ViewportLoad({
        selector: ".vimeo-player",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "vimeo-player" */'./components/vimeo-player').then((module) => {
                new module.default(selector)
            })
        },
    })

    new ViewportLoad({
        selector: ".variations_form",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "variations-attributes" */ './components/variations-attributes').then((module) => {
                new module.default(selector)
            })
        },
        singular: true
    })


    new ViewportLoad({
        selector: "form.cart",
        callback: ({ selector }) => {
            import(/* webpackChunkName: "cart-actions" */ './components/cart-actions').then((module) => {
                new module.default(selector)
            })
        }
    })
    
})